'use client';
import React from 'react';

import explodeConfetti from './utils';
import IMAGES from './utils/images';

export interface ConfettiOptionsType {
  isInfinite?: boolean;
  numParticles?: number;
  images?: string[];
  speedRange?: number[];
}

interface ConfettiProps {
  className?: string;
  options?: ConfettiOptionsType;
}

class Confetti extends React.Component<ConfettiProps> {
  static defaultProps = {
    className: '',
    options: {
      isInfinite: false,
      numParticles: 20,
      images: IMAGES,
      speedRange: [0.75, 1],
    },
  };

  canvas = React.createRef<HTMLCanvasElement>();

  componentDidMount(): void {
    this.resize();
    this.explode();
  }

  explode = (): void => {
    const { options } = this.props;

    if (this.canvas.current && options) {
      explodeConfetti(this.canvas.current, options);
    }
  };

  resize = (): void => {
    if (this.canvas.current) {
      this.canvas.current.width *= 2;
      this.canvas.current.height *= 2;
    }
  };

  render(): JSX.Element {
    const { className } = this.props;

    return (
      <canvas
        ref={this.canvas}
        className={`cur-h-full cur-absolute ${className}`}
      />
    );
  }
}
/* eslint-enable @typescript-eslint/no-non-null-assertion */

export default Confetti;
